import QuoteComparison from "./quoteComparison"
import { Consumer, Provider, QuoteComparisonContext } from "./quoteComparison.context"

export { Consumer, Provider, QuoteComparisonContext }
export { config } from "./_config"
export default QuoteComparison
